import React, { Component } from 'react';
import { connect } from 'react-redux';
import OfferDetailsView from './OfferDetails.view';

export class OfferDetailsContainer extends Component {

  constructor(props) {
    super(props);

    this.state = {
      clientModalActiveUsername: false,
      formState: {
        data: props.offer,
      }
    };

    this.onFormUpdate = this.onFormUpdate.bind(this);
    this.onFormUpdate = this.onFormUpdate.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.matchPrice = this.matchPrice.bind(this);
    this.undercut = this.undercut.bind(this);
    this.toggleClientModal = this.toggleClientModal.bind(this);
  }

  componentDidMount() {
    const { dispatch, offer } = this.props;
    dispatch({
      type: 'FETCH_OFFERS_BY_TYPE',
      payload: {
        type: offer.payment_method,
        offer_hash: offer.offer_hash,
      },
    });
  }

  toggleClientModal(username) {
    this.setState({
      clientModalActiveUsername: username,
    });
  }

  onFormUpdate(formState, actions) {
    this.setState({
      formState,
    });
  }

  matchPrice(margin) {
    this.setState({
      formState: {
        formState: this.state.formState,
        data: {
          ...this.state.formState.data,
          margin,
        },
      },
    });
  }

  undercut(margin) {
    this.matchPrice(margin - 0.2);
  }

  async submitForm(formState) {
    const { dispatch } = this.props;
    await dispatch({
      $global: true,
      type: 'UPDATE_OFFER_DETAILS',
      payload: {
        data: formState.data,
        onClose: this.props.onClose,
      },
    });

  }

  render() {
    return (<OfferDetailsView
      {...this.state}
      {...this.props}
      onFormUpdate={this.onFormUpdate}
      submitForm={this.submitForm}
      matchPrice={this.matchPrice}
      undercut={this.undercut}
      toggleClientModal={this.toggleClientModal}
    />);
  }

}

function mapStateToProps(state) {
  const { offers, liveBtcPrice, cachedBtcPrice } = state.offerDetails;
  return {
    offers,
    liveBtcPrice,
    cachedBtcPrice,
  };
}

export default connect(mapStateToProps)(OfferDetailsContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Offers/OfferDetails/OfferDetails.container.js